import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALINSTITUTIONITEM_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONITEM_LOAD_BY_TRIALINSTITUTION_ID,
    ACTION_TRIALINSTITUTIONITEM_LOAD_SITECLOSURE,
    ACTION_TRIALINSTITUTIONITEM_CREATE,
    ACTION_TRIALINSTITUTIONITEM_SAVE,

    ITrialInstitutionItemsLoadByTrialInstitutionIdAction,
    ITrialInstitutionItemsLoadSiteClosureAction,
    ITrialInstitutionItemLoadFailureAction,
    ITrialInstitutionItemLoadSuccessAction,
    ITrialInstitutionItemLoadByIdAction,

    ITrialInstitutionItemSaveSuccessAction,
    ITrialInstitutionItemSaveFailureAction,
    ITrialInstitutionItemSaveAction,

    ITrialInstitutionItemCreateAction,
    ITrialInstitutionItemCreateSuccessAction,
    ITrialInstitutionItemCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveFailure,
    SaveSuccess,

    CreateSuccess,
    CreateFailure,
} from "../actions/trialInstitutionItem";
import { trialInstitutionItemsApi } from "../services/trialInstitutionItems";


export const
    getTrialInstitutionItemByIdEpic = (action$): Observable<ITrialInstitutionItemLoadSuccessAction | ITrialInstitutionItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEM_LOAD_BY_ID)
            .mergeMap((action: ITrialInstitutionItemLoadByIdAction) => {
                return trialInstitutionItemsApi
                    .getTrialInstitutionItemById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionItem, undefined, undefined, undefined, undefined, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionItemsByTrialInstitutionIdEpic = (action$): Observable<ITrialInstitutionItemLoadSuccessAction | ITrialInstitutionItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEM_LOAD_BY_TRIALINSTITUTION_ID)
            .mergeMap((action: ITrialInstitutionItemsLoadByTrialInstitutionIdAction) => {
                return trialInstitutionItemsApi
                    .getTrialInstitutionItemsByTrialInstitutionId(action.trialInstitutionId)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionItems, response.trialInstitutionItemCategories, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionItemsSiteClosureEpic = (action$): Observable<ITrialInstitutionItemLoadSuccessAction | ITrialInstitutionItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEM_LOAD_SITECLOSURE)
            .mergeMap((action: ITrialInstitutionItemsLoadSiteClosureAction) => {
                return trialInstitutionItemsApi
                    .getTrialInstitutionItemsSiteClosure(action.trialInstitutionIds)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionItems, undefined, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialInstitutionItemEpic = (action$): Observable<ITrialInstitutionItemSaveSuccessAction | ITrialInstitutionItemSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEM_SAVE)
            .mergeMap((action: ITrialInstitutionItemSaveAction) => {
                return trialInstitutionItemsApi
                    .setTrialInstitutionItem(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialInstitutionItem, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialInstitutionItemEpic = (action$): Observable<ITrialInstitutionItemCreateSuccessAction | ITrialInstitutionItemCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEM_CREATE)
            .mergeMap((action: ITrialInstitutionItemCreateAction) => {
                return trialInstitutionItemsApi
                    .createTrialInstitutionItem(action.trialInstitutionId)
                    .map(response =>
                        CreateSuccess(response.trialInstitutionItem, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }
